import React from 'react';
import { useQuery } from 'react-query';
import axios from 'axios';
import { API_URL } from '../../../../links/API_LINKS';
import CircularProgress from '@mui/material/CircularProgress';
import { Box } from '@mui/material';
import CategoryHeader from './CategoryHeader';

const Index = () => {
  const fetchCategory = async () => {
    const res = await axios.get(API_URL + '/categories', {
      params: { limit: 0 },
    });
    return res;
  };
  const { status, data } = useQuery('fetchCategory', fetchCategory);
  // console.log(data);

  return (
    <div>
      {status === 'loading' && (
        <Box
          display='flex'
          justifyContent='center'
          alignItems='center'
          minHeight='50vh'
        >
          <CircularProgress />
        </Box>
      )}
      {status === 'error' && <div>Error fetching data</div>}
      {status === 'success' && (
        <Box>
          <CategoryHeader data={data.data.data} />{' '}
        </Box>
      )}
      <div></div>
    </div>
  );
};

export default Index;
